import { FieldConfig } from '../../models/form-field.model';
import { FormConfigInstance } from '../../services/form.service';

export interface FormButtonConfig {
  type: 'action' | 'submit' | 'cancel';
  layout?: 'raised' | 'fab' | 'basic' | 'flat';
  color?: 'primary' | 'warn' | 'accent' | false;
  classes?: string[];
  click?: (service: FormConfigInstance<any>) => void;
}

export class FormButtonField extends FieldConfig {

  button?: FormButtonConfig;
  containerStyles?: any;
  buttonStyles?: any;
  closeModalOnClick?: boolean;
  activeWithFormState?: boolean;
  disabled?: boolean | (<T = any>(value: T, service: FormConfigInstance) => boolean);

  constructor(o: FormButtonField) {
    super(o);
    this.type = 'button';

    if (Object.hasntKey(o, 'closeModalOnClick')) {
      this.closeModalOnClick = false;
    }

    if (Object.hasntKey(o, 'button')) {
      this.button = {
        type: 'action',
      };
    }

    if (Object.hasntKey(this.button, 'layout')) {
      this.button.layout = 'raised';
    }
  }
}
